import { BasicsClass } from '@/common/BasicsClass';

export class SoundEffectThemeAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getList', {
            url: '/admin/sound/list',
            name: 'list',
            label: '列表'
        }],
        ['add', {
            url: '/admin/sound/add',
            name: 'add',
            label: '添加音效主题'
        }],
        ['edit', {
            url: '/admin/sound/edit',
            name: 'edit',
            label: '编辑音效主题'
        }],
        ['publish', {
            url: '/admin/sound/publish',
            name: 'publish',
            label: '发布音效主题'
        }],
        ['delete', {
            url: '/admin/sound/del',
            name: 'delete',
            label: '删除音效主题'
        }],
        ['infoList', {
            url: '/admin/sound/infoList',
            name: 'infoList',
            label: '音效主题详情列表'
        }],
    ])


    // // 设备列表
    public getList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    public add(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('add').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public edit(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('edit').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public publish(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('publish').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public delete(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('delete').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }



    public getInfoList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('infoList').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }


}